module.exports = __webpack_public_path__ + "assets/media/google.b0cbcde2.svg";